const API_URL = process.env.VUE_APP_API_URL || "http://localhost:2000";

export const getMediaUrl = (imagePath) => {
  if (!imagePath) return null;
  if (imagePath.startsWith("http")) {
    return imagePath;
  }
  return API_URL + imagePath;
};

const sanitizeHtml = (html) => {
  // Remove <script> tags and their content
  let clean = html.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "");
  // Remove on* event handlers (onclick, onerror, onload, etc.)
  clean = clean.replace(/\s+on\w+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, "");
  // Remove javascript: URLs
  clean = clean.replace(/href\s*=\s*["']?\s*javascript\s*:/gi, 'href="');
  return clean;
};

export const processHtmlContent = (html) => {
  if (!html) return "";
  let processedHtml = sanitizeHtml(html);
  // Replace relative media URLs with absolute URLs for CKEditor images
  // Replace src="/media/..." with src="http://api.domain/media/..."
  processedHtml = processedHtml.replace(
    /src="\/media\//g,
    `src="${API_URL}/media/`,
  );
  // Also handle src='/media/...'
  processedHtml = processedHtml.replace(
    /src='\/media\//g,
    `src='${API_URL}/media/`,
  );
  return processedHtml;
};

export const API_BASE_URL = API_URL;

export default {
  install(Vue) {
    Vue.prototype.$mediaUrl = getMediaUrl;
    Vue.prototype.$apiUrl = API_URL;
    Vue.prototype.$processHtml = processHtmlContent;
  },
};
